"use client";

import { MotionValue } from "motion/react";
import * as motion from "motion/react-client";

export function ProgressTick({
  progress,
  size,
  strokeWidth = 2,
  color = "var(--yz-success)"
}: {
  progress: MotionValue<number>;
  size?: number;
  strokeWidth?: number;
  color?: string | MotionValue<string>;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      preserveAspectRatio="xMidYMid meet"
      style={{
        width: size ?? "100%",
        height: size ?? "100%",
        overflow: "visible"
      }}>
      <motion.path
        fill="none"
        strokeWidth={strokeWidth}
        stroke={color}
        d="M14,26 L 22,33 L 35,16"
        strokeDasharray="0 1"
        style={{ pathLength: progress }}
      />
    </svg>
  );
}
